
module navigation {
  'use strict';

  //https://github.com/mz026/angular_page_visibility/blob/master/dist/page_visibility.js

  export class VisibilityApiService implements IVisibilityApiService {

    public static $inject = [
      '$rootScope',
      '$document',
    ];

    constructor(
      private $rootScope: ng.IRootScopeService,
      private $document: ng.IDocumentService,
    ) {
      var getVisibilityKeys, hiddenKey, pageVisibility, visibilityChagedKey, _ref;

      getVisibilityKeys = function () {
        if (typeof ($document.prop('hidden')) !== 'undefined') {
          return ['hidden', 'visibilitychange'];
        } else if (typeof ($document.prop('mozHidden')) !== 'undefined') {
          return ['mozHidden', 'mozvisibilitychange'];
        } else if (typeof ($document.prop('msHidden')) !== 'undefined') {
          return ['msHidden', 'msvisibilitychange'];
        } else if (typeof ($document.prop('webkitHidden')) !== 'undefined') {
          return ['webkitHidden', 'webkitvisibilitychange'];
        }
      };

      _ref = getVisibilityKeys(), hiddenKey = _ref[0], visibilityChagedKey = _ref[1];

      $document.on(visibilityChagedKey, function () {
          $rootScope.$emit('visibility-change', $document.prop(hiddenKey));
      });
    }


    public subscribeOnVisibilityChange(
      scope: ng.IScope
      , callback: IVisibilityChangedListener
    ): void {

      var handler = this.$rootScope.$on('visibility-change', callback);
      if (scope) scope.$on('$destroy', handler);

    }
  }
}